import { PriorityKeys } from './rules';

export interface WorklistData {
  id: string;
  status: string;
  trigger: string;
  content: {
    title: string;
    description: string;
    priority: PriorityKeys;
  };
  attachments: {
    patientId?: string;
    patientFirstName?: string;
    patientLastName?: string;
    patientBirthday?: string;
    measurementId?: string;
    measurementType?: WorklistAttachmentType;
    measurementTimestamp?: string;
    reportId?: string;
    reportType?: string;
  };
  recipients: {
    groupId: string;
    groupName: string;
  };
  notificationCreationTimestamp: string;
  notes?: WorklistNote[];
  lastInteraction?: { timestamp: string; userId: string; userName?: string };
}

export interface WorklistNote {
  id: string;
  text: string;
  updaterId: string;
  creationTimestamp: string;
  updateTimestamp: string;
  userName?: string;
}

export enum WorklistAttachmentType {
  HeartRate = 'heartrate', // Old value, kept for backward compatibility with existing data, can be removed in future releases
  HeartRhythmMeasurement = 'heart-rhythm',
  BloodPressureMeasurement = 'blood-pressure',
  WeightMeasurement = 'weight-height',
}

export enum WorklistReportType {
  MeasurementReport = 'summary-report', // default
  BillingReport = 'billing-report',
}

export enum WorklistStatus {
  Unread = 'unread',
  Read = 'read',
  All = 'all',
}

export enum WorkListDrawerTab {
  Details = 'details',
  Notes = 'notes',
}
